<template>
    <v-app id="app">
        <v-card class="grlCardInfo">
            <v-breadcrumbs :items="obtRuta" class="grlClase">
                <template v-slot:item="{ item }">
                    <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
                        {{ item.text.toUpperCase() }}
                    </v-breadcrumbs-item>
                </template>
            </v-breadcrumbs>
        </v-card>
        <v-card>
            <v-img :src="imgTitle" class="grlCardImg">
                <div class="grlCardInfo">
                    <h1 class="my-auto hidden-sm-and-down">Acerca de la FAZ</h1>
                </div>
            </v-img>
        </v-card>
        <div class="gralMargenes" id="gralEspaciado">
            <hr>
            <div class="mvContGeneral">
                <div class="contOpciones">
                    <p v-if="mostrarMision == false" class="opcion" @click="mision">MISIÓN</p>
                    <p v-else class="opcion" id="color_opcion" @click="mision">MISIÓN</p>
                    <p v-if="mostrarVision == false" class="opcion" @click="vision">VISIÓN</p>
                    <p v-else class="opcion" id="color_opcion" @click="vision">VISIÓN</p>
                    <p v-if="mostrarPrincipios == false" class="opcion" @click="principios">
                        PRINCIPIOS FAZ
                    </p>
                    <p v-else class="opcion" id="color_opcion" @click="principios">
                        PRINCIPIOS FAZ
                    </p>
                    <p v-if="mostrarValores == false" class="opcion" @click="valores">
                        VALORES FAZ
                    </p>
                    <p v-else class="opcion" id="color_opcion" @click="valores">VALORES FAZ</p>
                </div>
                <v-card class="contInfo" elevation="5" v-show="mostrarMision">
                    <h2 id="gralEspaciado">MISIÓN</h2>
                    <hr />
                    <div class="contTexto">
                        <p>
                            La Facultad de Agricultura y Zootecnia es una
                            dependencia educativa cuya misión fundamental es la
                            formación integral de profesionales altamente
                            competitivos, con profundos valores éticos que
                            propendan al desarrollo sostenible
                            de la producción agropecuaria y agroindustrial,
                            en concordancia de las necesidades
                            de los sectores productivos y sociales, de las
                            leyes y políticas agropecuarias del
                            país, permitiendo impulsar el mejoramiento de las
                            condiciones de vida de la sociedad. Asimismo:
                        <ul>
                            <br>
                            <li>Generar nuevos conocimientos a través de la
                                investigación básica y aplicada.
                            </li>
                            <li>
                                Vinculación permanente con productores del sector,
                                a través de transferencia y apropiación de tecnología,
                                conferencias, seminarios, publicaciones especializadas
                                y demostraciones de campo, para comunicar los resultados
                                de la investigación desarrollada.
                            </li>
                            <li>
                                Difundir la cultura hacia la comunidad, de modo de
                                contribuir al fortalecimientode la identidad regional.
                            </li>
                        </ul>
                        </p>
                    </div>
                </v-card>
                <v-card class="contInfo" elevation="5" v-show="mostrarVision">
                    <h2 id="gralEspaciado">VISIÓN</h2>
                    <hr />
                    <div class="contTexto">
                        <p>
                            La FAZ, se propone ser líder en su ámbito de acción en la
                            formación de profesionales con alto nivel académico,
                            científico y tecnológico, en esta tesitura, la FAZ:
                        <ul>
                            <br>
                            <li>
                                Tendrá una oferta pertinente y de alta calidad que aportará
                                al conocimientoy promoverá el desarrollo sustentable de la
                                región, del estado y del país
                            </li>
                            <li>
                                Contribuirá al desarrollo agropecuario regional y nacional,
                                al inculcar a sus futuros profesionistas la utilización
                                de las mejores tecnologías de vanguardia en la producción
                                agropecuaria, acordes con las capacidades productivas del
                                entorno, sin comprometer laconservación del medio ambiente.
                                Impactando de manera positiva en la calidad de vida de
                                sus habitantes.
                            </li>
                            <li>
                                Será líder en la generación y difusión del conocimiento
                                de las ciencias agrobiológicas.
                            </li>
                            <li>
                                Contará con la acreditación de los programas de ingeniero
                                agrónomo (fitotecnia y zootecnia) con base en modelos
                                educativos pertinentes, flexibles y centrados en el aprendizaje.
                            </li>
                            <li>
                                Contará con los programas de maestría y doctorado reconocidos
                                dentro del Padrón Nacional de Posgrado de acuerdo con los
                                estándares de calidad propuestos por CONACYT. Esto como
                                consecuencia de la consolidación de sus Cuerpos Académicos
                                más notables en base a los parámetros del PRODEP.
                            </li>
                            <li>
                                Fortalecerá la vinculación con los diversos sectores que impactan
                                en los sistemas productivos en el área agropecuaria mediante
                                programas innovadores educativos, de investigación, difusión
                                y extensión considerando siempre un enfoque de desarrollo
                                sustentable.
                            </li>
                            <li>
                                Mantendrá altos estándares académicos y compromiso profesional.
                            </li>
                            <li>
                                Fomentará y promoverá la cultura y el deporte como parte de la
                                formación integral del estudiante.
                            </li>
                            <li>
                                La Facultad participará en los procesos de gestión administrativa
                                certificados, de rendición de cuentas a la sociedad, de aplicación
                                de normas dentro de las estructuras de gobierno universitario
                                flexibles, que la Universidad desarrolle para su mejor desempeño.
                            </li>
                        </ul>
                        </p>
                    </div>
                </v-card>
                <v-card class="contInfo" elevation="5" v-show="mostrarPrincipios">
                    <h2 id="gralEspaciado">PRINCIPIOS FAZ</h2>
                    <hr />
                    <div class="contTexto">
                        <p>
                            En concordancia con los principios de la UJED, los que regirán
                            el funcionamiento de la FAZ son:
                        <ul>
                            <br>
                            <li>La excelencia académica</li>
                            <li>El apego al derecho</li>
                            <li>
                                El pluralismo ideológico y el razonamiento científico, así como la
                                apertura a las diversas corrientes de pensamiento.
                            </li>
                        </ul>
                        </p>
                    </div>
                </v-card>
                <v-card class="contInfo" elevation="5" v-show="mostrarValores">
                    <h2 id="gralEspaciado">VALORES FAZ</h2>
                    <hr />
                    <div class="contTexto">
                        <p>
                            Son valores de la FAZ los siguientes:
                        <ul>
                            <br>
                            <li>La libertad de cátedra e investigación.</li>
                            <li>
                                La búsqueda constante del mejoramiento social, económico,
                                cultural y ambiental de la nación, el estado y la región.
                            </li>
                            <li>
                                El Trabajo en equipo, necesario para cumplir con los
                                objetivos y metas planteados en este plan.
                            </li>
                            <li>
                                El desarrollo continuo, con actitud abierta al cambio,
                                promoviendo la innovación tecnológica.
                            </li>
                            <li>
                                El respeto a la naturaleza.
                            </li>
                            <li>
                                Fomentar y promover la cultura.
                            </li>
                        </ul>
                        </p>
                    </div>
                </v-card>
            </div>
        </div>
    </v-app>
</template>
<script>
export default {
    data() {
        return {
            mostrarMision: true,
            mostrarVision: false,
            mostrarPrincipios: false,
            mostrarValores: false,
            imgTitle: require('../../assets/img/banner-acercaFaz.jpeg'),
            obtRuta: [
                {
                    text: 'Inicio',
                    disabled: false,
                    ruta: '/',
                },
                {
                    text: 'Conócenos',
                    disabled: true,
                    ruta: '/',
                },
                {
                    text: 'Acerca de la FAZ',
                    disabled: true,
                    ruta: '/',
                },
            ],
        };
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
        mision() {
            this.mostrarMision = true;
            this.mostrarPrincipios = false;
            this.mostrarValores = false;
            this.mostrarVision = false;
        },
        vision() {
            this.mostrarMision = false;
            this.mostrarPrincipios = false;
            this.mostrarValores = false;
            this.mostrarVision = true;
        },
        principios() {
            this.mostrarMision = false;
            this.mostrarPrincipios = true;
            this.mostrarValores = false;
            this.mostrarVision = false;
        },
        valores() {
            this.mostrarMision = false;
            this.mostrarPrincipios = false;
            this.mostrarValores = true;
            this.mostrarVision = false;
        },
    },
};
</script>
